import api from '@/api';
import router from '@/router';
import i18n from '@/lang';
import { goToLogin } from '@/helpers/authRedirect';

function isAuthRequest(url: string): boolean {
  return /\/(login|logout|register|forgot-password|reset-password)/.test(url);
}

function shouldRedirectToLogin(): boolean {
  const currentRoute = router.currentRoute.value;

  if (currentRoute.name === 'login') {
    return false;
  }

  return !currentRoute.matched.some((record) => record.meta.isPublic);
}

/**
 * Intercepts expired session responses (401 Unauthenticated and 419 CSRF)
 * so the user is redirected to login instead of staying on the current screen.
 */
export function setupSessionExpiryHandler() {
  api.apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;

      if (status === 419 || status === 401) {
        const url = String(error?.config?.url || '');
        const redirectToLoginPage = !isAuthRequest(url) && shouldRedirectToLogin();

        if (redirectToLoginPage) {
          const message = String(i18n.global.t('auth.session.expired'));

          if (error.response?.data && typeof error.response.data === 'object') {
            error.response.data.message = message;
          }

          goToLogin(router.currentRoute.value.fullPath);
        }
      }

      return Promise.reject(error);
    },
  );
}
